import { Collapse } from "@mui/material";
import type { TagFamilySectionProps } from "../../AssetsFilterTags.types";
import TagFamilyHeader from "./components/TagFamilyHeader/TagFamilyHeader";
import TagFamilyList from "./components/TagFamilyList/TagFamilyList";
import TagFamilyOverflow from "./components/TagFamilyOverflow/TagFamilyOverflow";
import { useTagVisibility } from "./TagFamilySection.hooks";

export default function TagFamilySection({
  familyName,
  tags,
  isOpen,
  onToggle,
  selectedTagIds,
  onTagToggle,
  searchText,
}: TagFamilySectionProps) {
  const { visibleTags, totalCount, hasMore, hiddenCount } = useTagVisibility(tags);

  return (
    <>
      <TagFamilyHeader
        familyName={familyName}
        totalCount={totalCount}
        isOpen={isOpen}
        onToggle={onToggle}
      />

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <TagFamilyList
          tags={visibleTags}
          selectedTagIds={selectedTagIds}
          onTagToggle={onTagToggle}
          searchText={searchText}
        />
        {hasMore && <TagFamilyOverflow hiddenCount={hiddenCount} />}
      </Collapse>
    </>
  );
}
